<div class="cipx-pill-switcher-container">
  <div class="cipx-pill-switcher-title" *ngIf="title">{{ title }}</div>
  <div class="cipx-pill-switcher">
    <div
      *ngFor="let option of options; trackBy: trackByFn"
      class="cipx-pill-switcher-item"
      [matTooltip]="option.tooltip"
      [class.cipx-pill-switcher-item-active]="value === option.id"
      (click)="onSelect(option)">
      <mat-icon *ngIf="option.icon" [svgIcon]="option.icon"></mat-icon>
      <span *ngIf="option.label" [class.ml-2]="option.icon" >{{ option.label }}</span>
    </div>
  </div>
</div>
